module.exports = __webpack_public_path__ + "static/media/chevron.7f5a1e27.svg";